/* ==========================================================================
   AVVO — Produktseite (AVVO-ANPASSUNG 24, 25.09.2026), gehört zu
   sections/avvo-produkt.liquid. Styles: assets/avvo-custom.css §9aa.

   - Galerie: wischen (Telefon), Vorschaubilder und Punkte folgen.
   - Menge −/+.
   - Warenkorb: Produkt und angeklickte Zusatzprodukte in einem Aufruf
     (/cart/add.js mit items), danach das Warehouse-Signal
     „product:added" → der Mini-Warenkorb lädt neu und öffnet sich,
     genau wie bei Warehouses eigenen Knöpfen.
   - Lieferzeit-Leiste und „heute verschickt" in Schweizer Zeit
     (Europe/Zurich), Mo–Fr bis 18 Uhr, kein Samstag (Kundenentscheid
     25.09.2026). Lieferung = Versandtag + 2 bis 3 Werktage (Einstellung
     in der Section). Schweizweite Feiertage zählen nicht als Werktage
     (seit 29.09.2026, Liste bei isHoliday), kantonale schon.
   - Kaufleiste unten am Telefon, sobald man am Knopf vorbei gescrollt hat.
   Neue Datei, nicht von Warehouse — bei einem Theme-Update mitkopieren.
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-avvo-pd]');
  if (!root) return;

  /* ---------------------------------------------------------------- Galerie */
  var gallery = root.querySelector('[data-avvo-gallery]');
  if (gallery) {
    var track = gallery.querySelector('[data-avvo-gallery-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-avvo-gallery-go]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.avvo-pd-gallery__dots i'));
    var current = 0;

    var setActive = function (index) {
      if (index === current) return;
      current = index;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    };
    var goTo = function (index) {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    };

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { goTo(k); setActive(k); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' && current < thumbs.length - 1) { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft' && current > 0) { e.preventDefault(); goTo(current - 1); }
    });
  }

  /* ---------------------------------------------------------------- Menge */
  var form = root.querySelector('.avvo-pd-form');
  /* AVVO-ANPASSUNG 53: der Zähler ist ein Zahlenfeld; die Wahl «1 oder 2» sind Radio-Knöpfe mit demselben Namen. */
  var qtyInput = form ? form.querySelector('input[name="quantity"][type="number"]') : null;
  var errorBox = root.querySelector('[data-avvo-error]');
  var showError = function (message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  };
  root.querySelectorAll('[data-avvo-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var max = parseInt(qtyInput.getAttribute('max'), 10);
      var value = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-avvo-qty'), 10);
      if (value < 1) value = 1;
      if (max > 0 && value > max) {
        value = max;
        showError(max === 1 ? 'Mehr als 1 Stück ist gerade nicht an Lager.' : 'Mehr als ' + max + ' Stück sind gerade nicht an Lager.');
      } else {
        showError('');
      }
      qtyInput.value = value;
    });
  });

  /* AVVO-ANPASSUNG 53: «Mehr als zwei Tücher?» öffnet den Zähler (ab 3) und
     wählt die Karten ab; eine Karte wählen schliesst ihn wieder. Der Zähler ist
     geschlossen deaktiviert, damit ein normales Absenden ohne Skript nur die
     gewählte Karte schickt. */
  var qcMore = root.querySelector('[data-avvo-qc-more]');
  var qcQty = root.querySelector('[data-avvo-qc-qty]');
  var qcRadios = form ? Array.prototype.slice.call(form.querySelectorAll('.avvo-pd-qc__input')) : [];
  if (qcMore && qcQty && qtyInput) {
    qcMore.addEventListener('click', function () {
      qcRadios.forEach(function (r) { r.checked = false; });
      qtyInput.disabled = false;
      qtyInput.value = Math.max(3, parseInt(qtyInput.value, 10) || 3);
      qcQty.hidden = false;
      qcMore.hidden = true;
      qtyInput.focus();
    });
    qcRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        qcQty.hidden = true;
        qtyInput.disabled = true;
        qcMore.hidden = false;
        showError('');
      });
    });
  }

  /* ---------------------------------------------------------------- Warenkorb */

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('[data-avvo-atc]');
      var picked = form.querySelector('input[name="quantity"]:checked') || qtyInput;
      var quantity = Math.max(1, parseInt(picked && picked.value, 10) || 1);
      var items = [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: quantity }];
      root.querySelectorAll('[data-avvo-addon]:checked').forEach(function (box) {
        items.push({ id: parseInt(box.value, 10), quantity: 1 });
      });

      showError('');
      if (button) button.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var url = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      }).then(function (result) {
        if (button) button.removeAttribute('disabled');
        if (!result.ok) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          showError((result.data && (result.data.description || result.data.message)) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
          return;
        }
        var total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { button: button, variant: null, quantity: total, productAdded: true }
        }));
        root.querySelectorAll('[data-avvo-addon]:checked').forEach(function (box) { box.checked = false; });
      }).catch(function () {
        if (button) button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        showError('Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
      });
    });
  }

  /* ---------------------------------------------------------------- Lieferzeit (Schweizer Zeit) */
  var DAY_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DAY_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  var zurichToday = function () {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day, 12)),   /* Mittag UTC: Tage zählen ohne Sommerzeit-Sprünge */
      minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10)
    };
  };
  /* Schweizweite Feiertage (Kundenentscheid 29.09.2026: nur nationale, keine
     kantonalen). Liste des Bundesamts für Strassen (Feiertage mit
     Sonntagsfahrverbot): Neujahr, Karfreitag, Ostermontag, Auffahrt,
     Pfingstmontag, 1. August, Weihnachten, Stephanstag. An diesen Tagen wird
     nicht verschickt und nicht zugestellt. Gleiche Liste in assets/avvo-cart.js (Mini-Warenkorb, Warenkorbseite). */
  var DAY_MS = 86400000;
  var easterSunday = function (y) {                       /* Gauss/Meeus, gregorianisch */
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1, 12);
  };
  var holidayCache = {};
  var isHoliday = function (date) {                        /* date = Mittag UTC des Schweizer Kalendertags */
    var y = date.getUTCFullYear();
    if (!holidayCache[y]) {
      var e = easterSunday(y), list = {};
      [Date.UTC(y, 0, 1, 12), e - 2 * DAY_MS, e + DAY_MS, e + 39 * DAY_MS, e + 50 * DAY_MS,
        Date.UTC(y, 7, 1, 12), Date.UTC(y, 11, 25, 12), Date.UTC(y, 11, 26, 12)].forEach(function (t) {
        list[new Date(t).toISOString().slice(0, 10)] = true;
      });
      holidayCache[y] = list;
    }
    return !!holidayCache[y][date.toISOString().slice(0, 10)];
  };
  var addDays = function (date, n) { return new Date(date.getTime() + n * 86400000); };
  var isWorkday = function (date) { var d = date.getUTCDay(); return d >= 1 && d <= 5 && !isHoliday(date); };
  var addWorkdays = function (date, n) {
    var d = date;
    while (n > 0) { d = addDays(d, 1); if (isWorkday(d)) n--; }
    return d;
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var fmt = function (date) { return DAY_SHORT[date.getUTCDay()] + ', ' + pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.'; };

  var timeline = root.querySelector('[data-avvo-timeline]');
  var stockNote = root.querySelector('[data-avvo-stock-note]');

  var renderDelivery = function () {
    var cutoff = parseInt((timeline && timeline.getAttribute('data-cutoff')) || '18', 10) * 60;
    var minDays = parseInt((timeline && timeline.getAttribute('data-min')) || '2', 10);
    var maxDays = parseInt((timeline && timeline.getAttribute('data-max')) || '3', 10);
    var now = zurichToday();
    var today = now.date;
    var shipToday = isWorkday(today) && now.minutes < cutoff;
    var ship = shipToday ? today : addWorkdays(today, 1);
    var tomorrow = addDays(today, 1);
    var shipTitle, shipSmall, note;

    if (shipToday) {
      var left = cutoff - now.minutes;
      var h = Math.floor(left / 60), m = left % 60;
      shipTitle = 'Heute verschickt';
      shipSmall = 'noch ' + (h > 0 ? h + ' Std. ' : '') + m + ' Min.';
      note = ', heute verschickt';
    } else if (ship.getTime() === tomorrow.getTime()) {
      shipTitle = 'Morgen verschickt';
      shipSmall = fmt(ship);
      note = ', Versand morgen';
    } else {
      shipTitle = 'Am ' + DAY_LONG[ship.getUTCDay()] + ' verschickt';
      shipSmall = fmt(ship);
      note = ', Versand am ' + DAY_LONG[ship.getUTCDay()];
    }

    if (stockNote) stockNote.textContent = note;
    if (!timeline) return;
    var first = addWorkdays(ship, minDays), last = addWorkdays(ship, Math.max(minDays, maxDays));
    var set = function (key, text) {
      var el = timeline.querySelector('[data-avvo-tl="' + key + '"]');
      if (el) el.textContent = text;
    };
    set('order', fmt(today));
    set('ship-title', shipTitle);
    set('ship', shipSmall);
    set('arrive', first.getTime() === last.getTime() ? fmt(first) : fmt(first) + ' bis ' + fmt(last));
    timeline.classList.toggle('is-ship-today', shipToday);
  };
  if (timeline || stockNote) {
    renderDelivery();
    setInterval(renderDelivery, 30000);
  }

  /* ---------------------------------------------------------------- Kaufleiste am Telefon */
  var sticky = root.querySelector('[data-avvo-sticky]');
  var anchor = root.querySelector('.avvo-pd-buy') || root.querySelector('.avvo-pd-notify');
  if (sticky && anchor) {
    var stickyAtc = sticky.querySelector('[data-avvo-sticky-atc]');
    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
    /* Beim Scrollen prüfen statt IntersectionObserver: der meldet sich nicht,
       wenn man über den Knopf hinweg springt (Link zu den Bewertungen). */
    var stickyTick = false;
    var updateSticky = function () {
      stickyTick = false;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      if (sticky.hidden === passed) {
        sticky.hidden = !passed;
        document.body.classList.toggle('avvo-pd-sticky-on', passed);
      }
    };
    var requestSticky = function () {
      if (stickyTick) return;
      stickyTick = true;
      requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll', requestSticky, { passive: true });
    window.addEventListener('resize', requestSticky);
    requestSticky();
  }
})();
